__turbopack_context__.v({
  "card": "ParagraphFeatures2Col-module__4cRFMa__card",
  "cardBody": "ParagraphFeatures2Col-module__4cRFMa__cardBody",
  "desc": "ParagraphFeatures2Col-module__4cRFMa__desc",
  "eyebrow": "ParagraphFeatures2Col-module__4cRFMa__eyebrow",
  "grid": "ParagraphFeatures2Col-module__4cRFMa__grid",
  "header": "ParagraphFeatures2Col-module__4cRFMa__header",
  "iconBox": "ParagraphFeatures2Col-module__4cRFMa__iconBox",
  "lead": "ParagraphFeatures2Col-module__4cRFMa__lead",
  "name": "ParagraphFeatures2Col-module__4cRFMa__name",
  "section": "ParagraphFeatures2Col-module__4cRFMa__section",
  "title": "ParagraphFeatures2Col-module__4cRFMa__title",
});
